import type { ReactNode } from "react";

/** หัวเรื่องของหน้าที่ฝังระบบอื่น — breadcrumb + ชื่อหน้า (+ แท็บถ้ามี) */
export function EmbedHead({
  crumb,
  title,
  right,
  note,
}: {
  crumb: string;
  title: string;
  right?: ReactNode;
  note?: ReactNode;
}) {
  return (
    <div className="embed-head">
      <div className="breadcrumb">{crumb}</div>
      {right ? (
        <div className="embed-head-row">
          <h1>{title}</h1>
          {right}
        </div>
      ) : (
        <h1>{title}</h1>
      )}
      {note && <div className="embed-note muted">{note}</div>}
    </div>
  );
}
